<!-- 滿意度圖表分析，畫面渲染元件 -->
<template>
  <div class="satisfaction-analysis-chat-container">
    <div :id="`chart-container_${page}`" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'SatisfactionAnalysisHistogramChartComponent',
  components: {},
  props: {
    page: {
      type: Number,
      default: 0,
    },
    legendData: {
      type: Array,
      default: () => [],
    },
    xAxisData: {
      type: Array,
      default: () => [],
    },
    seriesData: {
      type: Array,
      default: () => [],
    },
  },
  async activated() {},
  data() {
    return {}
  },
  created() {},
  mounted() {
    // console.log(this.legendData, this.xAxisData, this.seriesData);
    setTimeout(() => {
      this.chatInit()
    }, 200)
  },
  methods: {
    chatInit() {
      let vm = this
      let dom = document.getElementById(`chart-container_${this.page}`)
      // let dom = document.getElementById(`chart-container_${count}`);
      let myChart = echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })

      var app = {}

      var option

      const posList = [
        'left',
        'right',
        'top',
        'bottom',
        'inside',
        'insideTop',
        'insideLeft',
        'insideRight',
        'insideBottom',
        'insideTopLeft',
        'insideTopRight',
        'insideBottomLeft',
        'insideBottomRight',
      ]
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90,
        },
        align: {
          options: {
            left: 'left',
            center: 'center',
            right: 'right',
          },
        },
        verticalAlign: {
          options: {
            top: 'top',
            middle: 'middle',
            bottom: 'bottom',
          },
        },
        position: {
          options: posList.reduce(function (map, pos) {
            map[pos] = pos
            return map
          }, {}),
        },
        distance: {
          min: 0,
          max: 100,
        },
      }
      app.config = {
        rotate: 90,
        align: 'left',
        // align: "center",
        // verticalAlign: "middle",
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15,
        onChange: function () {
          const labelOption = {
            rotate: app.config.rotate,
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            position: app.config.position,
            distance: app.config.distance,
          }

          myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          })
        },
      }
      const labelOption = {
        show: false,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {},
        },
      }

      if (this.seriesData && this.seriesData.length > 0) {
        this.seriesData.forEach((f, index) => {
          if (index == 0) {
            f.barGap = 0
          }
          f.label = labelOption
        })
      }
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          // data: ["非常不滿意", "不太滿意", "普通", "滿意", "非常滿意"],
          data: vm.legendData,
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            // mark: { show: true },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ["line", "bar", "stack"] },
            // restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            position: {
              top: '200px',
            },
            type: 'category',
            axisTick: { show: false },
            data: vm.xAxisData,
            // data: [
            //   "1.對於本次旅遊的整體評價",
            //   "2.行程景點安排",
            //   "3.餐廳飲食安排",
            //   "4.住宿旅館安排",
            //   "5.交通工具及路線安排",
            // ],
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              textStyle: {
                color: '#333',
                fontSize: 12,
              },
              formatter: '{value} %',
            },
          },
        ],
        series: vm.seriesData,
        // series: [
        //   {
        //     name: "非常不滿意",
        //     type: "bar",
        //     barGap: 0,
        //     label: labelOption,
        //     emphasis: {
        //       focus: "series",
        //     },
        //     data: [100, 100, 0, 100, 100],
        //   },
        //   {
        //     name: "不太滿意",
        //     type: "bar",
        //     label: labelOption,
        //     emphasis: {
        //       focus: "series",
        //     },
        //     data: [0, 100, 0, 0, 0],
        //   },
        //   {
        //     name: "普通",
        //     type: "bar",
        //     label: labelOption,
        //     emphasis: {
        //       focus: "series",
        //     },
        //     data: [0, 0, 0, 0, 0],
        //   },
        //   {
        //     name: "滿意",
        //     type: "bar",
        //     label: labelOption,
        //     emphasis: {
        //       focus: "series",
        //     },
        //     data: [0, 0, 0, 0, 0],
        //   },
        //   {
        //     name: "非常滿意",
        //     type: "bar",
        //     label: labelOption,
        //     emphasis: {
        //       focus: "series",
        //     },
        //     data: [0, 0, 0, 0, 0],
        //   },
        // ],
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  position: relative;
  height: 50vh;
  overflow: hidden;
}
</style>
